export default __webpack_public_path__ + "static/media/Kylie 9781408322208.0eb52f25.jpg";